export const favouriteComponent = (state: any, uiEngineProps: any) => ({
  favouriteComponent: uiEngineProps.hostProps().favouriteComponent
});
